import { useEffect, useState } from 'react'

/**
 * Tracks the `prefers-reduced-motion: reduce` media query.
 *
 * Lifted out of DotSphereSpinner, which had the only copy in the codebase and now imports this
 * one. It is a hook rather than a CSS media query because the callers need to change BEHAVIOUR,
 * not just suppress a transition: the spinner holds its first frame, and the scheduler diagram
 * pins itself to step-by-step and never auto-plays.
 *
 * Starts `false` and corrects in an effect, so server/first-paint is the motion default and a
 * user who prefers reduced motion gets one frame of the default before the correction lands.
 */
export function usePrefersReducedMotion(): boolean {
    const [reduced, setReduced] = useState(false)

    useEffect(() => {
        if (typeof window === 'undefined' || !window.matchMedia) return
        const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
        const update = () => setReduced(mq.matches)
        update()
        mq.addEventListener?.('change', update)
        return () => mq.removeEventListener?.('change', update)
    }, [])

    return reduced
}

export default usePrefersReducedMotion
